import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { api, ApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useToast } from "@/components/toast";
import { Button, ErrorBox, Field } from "@/components/ui";
import { AuthShell } from "@/components/auth-shell";
import { Logo } from "@/components/logo";

export default function Login() {
  const navigate = useNavigate();
  const toast = useToast();
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!email.trim() || !password) return setError("Enter your email and password.");
    setLoading(true);
    try {
      const res = await api("/auth/login", { method: "POST", auth: false, body: { email: email.trim(), password } });
      await signIn(res.token, res.user);
      navigate("/", { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 403 && err.detail === "email_not_verified") {
        api("/auth/resend-code", { method: "POST", auth: false, body: { email: email.trim() } }).catch(() => {});
        toast("Please verify your email first. We sent you a new code.", "info");
        navigate(`/verify?email=${encodeURIComponent(email.trim().toLowerCase())}`);
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell backTestId="login-back-button" onBack={() => navigate("/landing")}>
      <div className="mb-6"><Logo size="lg" /></div>
      <h1 className="text-[38px] leading-tight">Welcome back</h1>
      <p className="mb-8 mt-1 text-[15px] text-muted-foreground">Log in to discover your LOVE NET matches.</p>
      <form onSubmit={submit} noValidate data-testid="login-form">
        <Field testId="login-email-input" label="Email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
        <Field testId="login-password-input" label="Password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your password" />
        {error ? <ErrorBox testId="login-error">{error}</ErrorBox> : null}
        <Button type="submit" testId="login-submit-button" title="Log in" loading={loading} className="mt-2 w-full" />
      </form>
      <button data-testid="login-register-link" onClick={() => navigate("/register", { replace: true })} className="mt-4 w-full py-3 text-sm text-muted-foreground">
        New to LOVE NET? <span className="font-bold text-primary">Join now</span>
      </button>
    </AuthShell>
  );
}
